export default "<ion-content>\r\n  <app-tabs #dashboardTabs [selectedTab]=\"selectedTab\" [tabLinks]=\"tabLinks\"></app-tabs>\r\n</ion-content>"